import { render, staticRenderFns } from "./SearchRNA.vue?vue&type=template&id=159c2ea8&"
import script from "./SearchRNA.vue?vue&type=script&lang=js&"
export * from "./SearchRNA.vue?vue&type=script&lang=js&"
import style0 from "./SearchRNA.vue?vue&type=style&index=0&id=159c2ea8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports